import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  qualityResultsApi,
  configurationsApi,
  reportsApi,
  dashboardsApi,
  authApi,
  usersApi,
  materialsApi,
  suppliersApi,
  productCardApi,
  ordersApi,
  packagingApi,
  standAloneApi,
  taskHubApi,
  taskHubExecutionApi,
  ediApi,
  batchesApi,
  productionAnalysisApi,
} from "shared/api";
import { userReducer } from "./user/slice";

const userPersistConfig = {
  key: "user",
  storage,
  whitelist: ["token"],
};

export const rootReducer = combineReducers({
  user: persistReducer(userPersistConfig, userReducer),
  [authApi.reducerPath]: authApi.reducer,
  [usersApi.reducerPath]: usersApi.reducer,
  [materialsApi.reducerPath]: materialsApi.reducer,
  [suppliersApi.reducerPath]: suppliersApi.reducer,
  [productCardApi.reducerPath]: productCardApi.reducer,
  [ordersApi.reducerPath]: ordersApi.reducer,
  [packagingApi.reducerPath]: packagingApi.reducer,
  [qualityResultsApi.reducerPath]: qualityResultsApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [dashboardsApi.reducerPath]: dashboardsApi.reducer,
  [configurationsApi.reducerPath]: configurationsApi.reducer,
  [standAloneApi.reducerPath]: standAloneApi.reducer,
  [taskHubApi.reducerPath]: taskHubApi.reducer,
  [taskHubExecutionApi.reducerPath]: taskHubExecutionApi.reducer,
  [ediApi.reducerPath]: ediApi.reducer,
  [batchesApi.reducerPath]: batchesApi.reducer,
  [productionAnalysisApi.reducerPath]: productionAnalysisApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
